// Stable built-in report names come from the reports API. Custom names remain unchanged.
const definitions = {
  "Warehouse place inventory": { key: 'placeInventory', icon: 'view_module' },
  "Warehouse daily inventory": { key: 'dailyInventory', icon: 'inventory_2' },
  "Delivery requests and orders statistics": { key: 'deliveryOrders', icon: 'local_shipping' },
  "Delivery requests statistics": { key: 'deliveryStats', icon: 'query_stats' },
  "Sent orders stats for the period": { key: 'sentOrders', icon: 'outbox' },
  "Account monthly documents": { key: 'monthlyDocuments', icon: 'calendar_month' },
  "Account custom finances": { key: 'accountFinances', icon: 'account_balance_wallet' },
  "Delivery requests payments": { key: 'deliveryPayments', icon: 'payments' },
  "Returned orders stats for the period": { key: 'returnedOrders', icon: 'assignment_return' },
};
export function reportDefinition(name) { return Object.prototype.hasOwnProperty.call(definitions, name) ? definitions[name] : null; }
export function categoryKey(name) {
  const value = String(name || '').trim().toLowerCase();
  const aliases = {
    products: 'products', goods: 'products', 'товары': 'products',
    finance: 'finance', finances: 'finance', 'финансы': 'finance',
    delivery: 'delivery', shipping: 'delivery', 'доставка': 'delivery',
    warehousing: 'operations',
    'warehouse operations': 'operations', 'warehousing operations': 'operations',
    'storage operations': 'operations', 'складские операции': 'operations',
    'складкие операции': 'operations',
  };
  return Object.prototype.hasOwnProperty.call(aliases, value) ? aliases[value] : null;
}
